<script setup>
import {
  HorizontalNavGroup,
  HorizontalNavLink,
} from '@layouts/components'

const props = defineProps({
  navItems: {
    type: null,
    required: true,
  },
  order: {
    type: Boolean,
    default: true,
  },
  quickAccess: {
    type: Object,
    default: () => {},
  },
})

const resolveNavItemComponent = item => {
  if ('children' in item && item.children.length > 0)
    return HorizontalNavGroup
  
  return HorizontalNavLink
}

const orderText = element => {
  if(element.length > 0){

    return element.sort((a, b) => {
      var textA = a.title
      var textB = b.title
      if(a.i18n  === b.i18n){
        textA = textA.toUpperCase()
        textB = textB.toUpperCase()
      } else {
        textA = (useNuxtApp().$i18n.te(a.i18n) ? useNuxtApp().$i18n.t(a.i18n) : useNuxtApp().$i18n.te(a.title) ? useNuxtApp().$i18n.t(a.title) : a.title).toUpperCase()
        textB = (useNuxtApp().$i18n.te(b.i18n) ? useNuxtApp().$i18n.t(b.i18n) : useNuxtApp().$i18n.te(b.title) ? useNuxtApp().$i18n.t(b.title) : b.title).toUpperCase()
      }
    
      return (textA < textB) ? -1 : (textA > textB) ? 1 : 0
    })
  }
  
  return element
}

const enrolmentAccess = computed(() => {
  const quickAccess = [] //props.quickAccess

  props.navItems.map(nav => {
    if(!quickAccess.includes(nav)){
      quickAccess.push(nav)
    }
  })
  if (!props.order) { return quickAccess }

  quickAccess.forEach(element => {
    if ('children' in element) {
      element.children = orderText(element.children)
      if(element.children.length > 0) {
        element.children.forEach(subElement => {
          if ('children' in subElement){
            subElement.children = orderText(subElement.children)
          }
        })
      }
    }
  })

  return orderText(quickAccess)
})
</script>

<template>
  <ul class="nav-items">
    <Component
      :is="resolveNavItemComponent(item)"
      v-for="(item, index) in enrolmentAccess"
      :key="index"
      :item="item"
    />
  </ul>
</template>

<style lang="scss">
.layout-wrapper.layout-nav-type-horizontal {
  .nav-items {
    display: flex;
    flex-wrap: wrap;
  }
}
</style>
